var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { checkIfSearchable, getResourceId, useResourceSearchDropdown, } from 'ziphy-web-shared/basic/entities/notes/resources';
import { isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers';
import { Dropdown, DropdownContent } from 'ziphy-web-shared/basic/lib/functional';
import { BadgeNew } from 'ziphy-web-shared/basic/lib/simple';
import PlaceholderHelpers from '../../placeholder/Placeholder.helpers';
import styles from './PlaceholderResource.module.scss';
const { getBadgeColor } = PlaceholderHelpers;
const PlaceholderResource = ({ elementId, data, $section, onChange, isBlocked, isLoading, encounterId, isPlain, isInvalid, }) => {
    const isMulti = data.multi;
    const { resourceSearchDropdown, isAddingNew, selectedItems, handleOnDone, handleOnReset, handleOnRemoveAll, handleOnRemove, contentMountEventName, openResourceModal, } = useResourceSearchDropdown({
        encounterId,
        resourceContext: data,
        initialSelected: data.fhirRef,
        isMulti,
        isEdit: true,
        practiceSettings: $section.practiceSettings,
        onSelectResource: useCallback((fhirRef) => __awaiter(void 0, void 0, void 0, function* () { return onChange(data.id, { fhirRef }); }), [data]),
    });
    const isSearchable = checkIfSearchable(data.searchPreference);
    const values = useMemo(() => {
        return (Array.isArray(data.value) ? data.value : [data.value]).filter((x) => !isAbsoluteEmpty(x));
    }, [data.value]);
    const resourceIds = useMemo(() => {
        return (Array.isArray(data.fhirRef) ? data.fhirRef : [data.fhirRef])
            .filter((x) => !isAbsoluteEmpty(x))
            .map((x) => getResourceId(x));
    }, [data.fhirRef]);
    return (_jsx(Dropdown, Object.assign({ ref: resourceSearchDropdown.dropdownRef, renderButton: ({ fieldRef, onToggle }) => (_jsx(BadgeNew, { valueId: `ref_${data.id}`, ref: fieldRef, placeholder: data.title, editable: !isBlocked && !data.blocked && !isPlain, color: getBadgeColor(data), value: resourceIds.length > 0
                ? resourceIds.map((resourceId, index) => (_jsxs("span", Object.assign({ onClick: (event) => {
                        if (!isSearchable || (event === null || event === void 0 ? void 0 : event.ctrlKey) || (event === null || event === void 0 ? void 0 : event.metaKey)) {
                            openResourceModal(resourceId);
                        }
                        else {
                            onToggle();
                        }
                    } }, { children: [index > 0 && ', ', values[index]] }), resourceId)))
                : undefined, onClick: resourceIds.length === 0 ? () => onToggle() : undefined, className: classNames(styles.badge, {
                [styles.badgeGray]: isBlocked,
                [styles.badgePurple]: data.blocked && data.source === 'system',
            }), showTextSelection: false, isLoading: isLoading, isPlain: isPlain, isInvalid: isInvalid })), onClickOutside: isAddingNew ? () => { } : undefined, onOpen: () => {
            resourceSearchDropdown.reloadAsyncItems();
        }, onAfterClose: () => {
            resourceSearchDropdown.setSearchString('');
            handleOnReset();
        }, className: styles.dropdown, resizeDeps: [resourceSearchDropdown.searchString, resourceSearchDropdown.totalFilteredItems], "data-placeholder": true, id: elementId }, { children: _jsx(DropdownContent, { searchField: {
                value: resourceSearchDropdown.searchString,
                onChange: resourceSearchDropdown.setSearchString,
            }, isLoading: resourceSearchDropdown.isLoading, items: resourceSearchDropdown.filteredItems, isManualCloseControl: true, isMulti: isMulti, 
            // selectedItems={selectedItems}
            onDone: handleOnDone, onRemoveAll: handleOnRemoveAll, onRemoveItem: handleOnRemove, mountEventName: contentMountEventName }, 'resources') })));
};
export default observer(PlaceholderResource);
